import React, { FC } from 'react';
import { FormattedNumber } from 'react-intl';

import { PriceProps } from './types';

export const Price: FC<PriceProps> = ({ price, noPennies, numberOfGuests }) =>
  price?.amount || price?.amount === 0 ? (
    <FormattedNumber
      value={(price.amount / 100) * (numberOfGuests || 1)}
      currency={price.currencyCode}
      style="currency" // eslint-disable-line
      maximumFractionDigits={noPennies ? 0 : 2}
    />
  ) : null;
